module.exports = __webpack_public_path__ + "img/more-vertical.c0e7b588.svg";